module.exports = __webpack_public_path__ + "static/media/info.af3f0f38.svg";